var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-wrapper"},[_c('vue-audio',{attrs:{"file":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }